import { SET_ONBOARDING_CONFIG, SHOW_ONBOARDING_QUESTIONNAIRE, HIDE_ONBOARDING_QUESTIONNAIRE, } from '../constants/actions';
export const initialState = {
    // Controlled by SET_ONBOARDING_CONFIG
    zipCode: '',
    email: '',
    eligible: false,
    trial: '',
    variant: '',
    // Controlled by SHOW_ONBOARDING_QUESTIONNAIRE, HIDE_ONBOARDING_QUESTIONNAIRE
    showQuestionnaire: false,
};
/**
 * Reduces register state.
 *
 * Controls the onboarding modal configuration and
 * when the onboarding modal is displayed
 */
export const onboardingReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ONBOARDING_CONFIG:
            return {
                ...state,
                ...action.config,
            };
        case SHOW_ONBOARDING_QUESTIONNAIRE:
            return {
                ...state,
                showQuestionnaire: true,
            };
        case HIDE_ONBOARDING_QUESTIONNAIRE:
            return {
                ...state,
                showQuestionnaire: false,
            };
        default:
            return state;
    }
};
